import { EmailInput, OptionalPhoneInput } from '@v0y4ge/api-contracts';

/** Shared UI callbacks for the design-system fields; the contract owns syntax. */
export function validatePhoneInput(value: string): string | undefined {
  const result = OptionalPhoneInput.safeParse(value);
  return result.success ? undefined : result.error.issues[0]?.message;
}

export function validateEmailInput(value: string): string | undefined {
  if (!value.trim()) return undefined;
  return EmailInput.safeParse(value).success ? undefined : 'Enter a valid email address.';
}
